module.exports = __webpack_public_path__ + "img/asset-monitor.bfeef158.png";